import React from 'react';
import { Button } from 'react-bootstrap';
import { formatDateTimeYearFirst } from '../../shared/utils/date';

export default class BSTableDateTimeEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialDate: formatDateTimeYearFirst(props.defaultValue),
            date: props.defaultValue ? formatDateTimeYearFirst(props.defaultValue) : '',
        };
    }

    handleClick = () => {
        if (this.state.date !== this.state.initialDate) {
            this.updateData();
        }
    };

    updateData = () => {
        this.props.onUpdate(formatDateTimeYearFirst(this.state.date));

        if (this.props.onUpdateCallback) {
            this.props.onUpdateCallback(this.props.row);
        }
    };

    render() {
        return (
            <div>
                <input
                    ref="date"
                    type="text"
                    value={this.state.date}
                    placeholder="YYYY-MM-DD HH:mm"
                    style={{ width: 160, paddingLeft: 5, marginRight: 5 }}
                    onChange={e => this.setState({ date: e.currentTarget.value })}
                />
                <Button bsSize="small" bsStyle="primary" onClick={this.handleClick}>
                    Save
                </Button>
            </div>
        );
    }
}
